import { User } from '../../../../../services/entities/impl/blfApi/schemas/user';

/**
 * Utility function to filter users based on customer ID
 * @param users - Array of users to filter
 * @param filterCustomerID - Customer ID to filter by
 * @returns Filtered array of users
 */
export const filterUsers = (
  users: User[] | undefined,
  filterCustomerID: string
): User[] => {
  if (!users) return [];

  // First filter the users based on the filterCustomerID if provided
  if (filterCustomerID !== '') {
    // User can have multiple roles and customerID's associated with those roles, so we need to check if any of the roles' resourceID matches the filterCustomerID.  Then do an additional check if customerID matches the filterCustomerID.
    return users.filter(
      (user) =>
        user.roles.some((role) => role.resourceID === filterCustomerID) ||
        user.customerID === filterCustomerID
    );
  }

  return users;
};
